import React from "react";

const CalculateUploadTime = (
  speedCounter,
  fileSize,
  setResult,
  speedType,
  sizeType
) => {
  let convertedFileSize;
  switch (speedType) {
    case "Kbps":
      if (sizeType === "KB") {
        convertedFileSize = fileSize * 8.19;
      } else if (sizeType === "MB") {
        convertedFileSize = fileSize * 1024 * 8.19;
      } else if (sizeType === "GB") {
        convertedFileSize = fileSize * 1024 * (1024 * 8.19);
      }
      break;
    case "Mbps":
      if (sizeType === "KB") {
        convertedFileSize = fileSize * 0.008192;
      } else if (sizeType === "MB") {
        convertedFileSize = fileSize * 1024 * 0.008192;
      } else if (sizeType === "GB") {
        convertedFileSize = fileSize * 1024 * (1024 * 0.008192);
      }
      break;
    case "Gbps":
      if (sizeType === "KB") {
        convertedFileSize = fileSize * 0.000008;
      } else if (sizeType === "MB") {
        convertedFileSize = fileSize * 1024 * 0.000008;
      } else if (sizeType === "GB") {
        convertedFileSize = fileSize * 1024 * (1024 * 0.000008);
      }
      break;
    default:
      break;
  }
  const resultInSeconds = convertedFileSize / speedCounter;

  Number.prototype.toHHMMSS = function () {
    var sec_num = parseInt(this, 10);
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - hours * 3600) / 60);
    var seconds = sec_num - hours * 3600 - minutes * 60;

    if (hours < 10) {
      hours = "0" + hours;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }

    if (!hours || !minutes || !seconds) return 0;
    else return hours + ":" + minutes + ":" + seconds;
  };
  if (resultInSeconds.toHHMMSS()) {
    setResult(resultInSeconds.toHHMMSS());
  } else {
    setResult("error");
  }
};

export default CalculateUploadTime;
